import type { SVGProps } from "react";
export interface PieIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PieIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PieIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.628 15.358a1.126 1.126 0 0 1 2.019.99l-1.834 4.277a4.12 4.12 0 0 1-3.791 2.5H7.978c-1.65 0-3.14-.983-3.79-2.5l-1.835-4.277-.04-.108a1.125 1.125 0 0 1 2.058-.882l.05.104 1.833 4.277c.296.69.975 1.136 1.724 1.136h8.044c.75 0 1.427-.447 1.723-1.136l1.834-4.277zm-9.622-3.355a1.124 1.124 0 0 1-2.013-1.006zm6-1.006a1.125 1.125 0 1 1-2.013 1.006l-.5-1L14.5 10.5l1.006-.504zm-7.512-1a1.125 1.125 0 0 1 2.013 1.006l-.501 1-1.007-.504-1.006-.502zm5.504-.503a1.125 1.125 0 0 1 1.508.503l-2.012 1.006a1.125 1.125 0 0 1 .504-1.509M14 .875a1.125 1.125 0 0 1 0 2.25.96.96 0 0 0-.848.514l-.06.14-.025.077-.042.107a1.126 1.126 0 0 1-2.092-.819l.025-.076.09-.242A3.21 3.21 0 0 1 14 .875"
      />
      <path
        fill={color}
        d="M18 13.374c.514 0 .961.349 1.089.846.087.337.463.654.911.654a.874.874 0 0 0 .787-1.258l-.065-.11c-.167-.243-.517-.691-.75-1.207l-.092-.224a8.3 8.3 0 0 0-5.168-5.027 3.121 3.121 0 0 1-5.424 0 8.3 8.3 0 0 0-5.168 5.027c-.11.304-.273.592-.433.84l-.41.591A.875.875 0 0 0 4 14.874c.448 0 .825-.317.912-.654l.063-.179a1.125 1.125 0 0 1 2.115.179c.087.337.463.654.911.654s.824-.317.911-.654l.062-.179a1.126 1.126 0 0 1 2.116.179c.087.337.464.654.912.654.447 0 .822-.317.91-.654l.062-.179a1.125 1.125 0 0 1 2.117.179c.087.337.462.654.91.654.447 0 .824-.317.91-.654l.064-.179c.178-.4.577-.667 1.026-.667Zm-6-8.749a.874.874 0 0 0-.873.84l.017.112q.005.06.004.12a.873.873 0 0 0 1.702 0q0-.112.022-.225a.873.873 0 0 0-.871-.847ZM23.126 14A3.124 3.124 0 0 1 20 17.125a3.25 3.25 0 0 1-2.001-.7c-.56.44-1.266.7-2 .7a3.25 3.25 0 0 1-1.999-.7c-.56.44-1.266.7-2 .7s-1.44-.26-2-.7c-.561.44-1.266.7-2 .7a3.25 3.25 0 0 1-2.001-.7c-.56.44-1.266.7-2 .7a3.125 3.125 0 0 1-2.578-4.892l.381-.548c.093-.139.156-.251.202-.379l.252-.628a10.55 10.55 0 0 1 6.7-5.882 3.124 3.124 0 0 1 6.086 0 10.54 10.54 0 0 1 6.953 6.51l.084.186c.1.184.252.382.5.741l.122.194c.27.462.424 1.001.424 1.573Z"
      />
    </svg>
  );
}
